import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useTable } from "react-table";
import ReactDOM from "react-dom";
import CloseIcon from "../../assets/images/close.png";
import { useDrop } from 'react-dnd';
import UnitsTopBar from "../../components/UnitsTopBar";
import Popup from 'reactjs-popup';
/*
import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownRed from "../../assets/images/arrow_down_red.png";
import ArrowUpGreen from "../../assets/images/arrow_up_green.png";

import LOADER from "../../assets/images/loader.svg";
import LOADER_BLUE from "../../assets/images/loader_blue.svg";


import PREVENTIVE from "../../assets/images/preventive.svg";
*/
import AdminTable from "../Admin/users/AdminTable";
import { useDrag, useDragLayer, DragPreviewImage } from "react-dnd";
import { useDragDropManager } from "react-dnd";
import DepartmentsScreen, { } from "../Admin/screens/DepartmentsScreen"
import RiskAssessmentScreen from "../Admin/screens/RiskAssessmentScreen";
import { useHistory } from "react-router-dom";
import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownGreen from "../../assets/images/arrow_down_green.png";
import Nill from "../../assets/images/nill.png";
import UnitsSideBar from "../../components/UnitsSideBar";
import { Disable } from 'react-disable';
import { TfiTrash, TfiAlert, TfiLightBulb } from "react-icons/tfi";
import { openOverlay, deleteRisk, gotoRiskDashboard, gotoBowtie, getControls_Report } from "../../store/actions/riskActions";
import { setSidebarCollapsed } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import RiskMatrixSingle from '../../components/Charts/Risk/RiskMatrixSingle';
import { assignControlToRisk, closeOverlay, editRiskSave, getRisk, getLevels, addComment, addControl, addAction, addAttachment, editRisk, editControl, editAction, deleteControl, deleteAction, aiControlDrop } from "../../store/actions/riskActions";
import ControlOverlay from '../../components/Control/ControlOverlay';
import ActionOverlay from '../../components/Action/ActionOverlay';
import Select from 'react-select'
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import debounce from "lodash/debounce";
import { set } from 'lodash';
import { fromArray } from '@amcharts/amcharts4/.internal/core/utils/Iterator';
import { closeIncident } from '../../store/actions/incidentActions';
import IncidentDetailsForm from "../../components/Incidents/IncidentOverlay";
import callOpenAIAPI from '../../utils/openAI';
import DraggableControlCard from '../../components/Risk/DraggableControlCard';
import TopBar from '../../components/TopBar';
import Sidebar from '../../components/Sidebar';
import { getRiskDashboardData } from "../../store/actions/dashboardActions";
import { getComplianceStandardsByCompany } from "../../store/actions/complianceActions"
import ComplianceTopBar from "../../components/ComplianceTopBar";
import { useParams } from "react-router-dom";
import { getCompany, deleteDepartment, updateDepartment, deleteCompany } from "../../store/actions/departmentActions";
import NotificationsOverlay from "../../components/Departments/NotificationsOverlay";
import { LuPanelLeft, LuPanelRight } from "react-icons/lu"


function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: 'none', // Remove the border
    boxShadow: state.isFocused
      ? 'inset 0 -2px 0 0 #3b3b3b' // Add a focused bottom border effect using boxShadow
      : 'none', // Default to light gray bottom shadow
    backgroundColor: '#F8F8F8',
    padding: 1,
    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
    '&:hover': {
      boxShadow: state.isFocused
        ? 'inset 0 -2px 0 0 #3b3b3b' // Keep dark blue on hover if focused
        : 'inset 0 -2px 0 0 #ccc', // Otherwise, show light gray on hover
    },
  }),

  menu: (provided) => ({
    ...provided,
    border: 'none', // Remove the border around the menu
    zIndex: 999999999999, // Ensures the menu appears above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#3b3b3b'
      : state.isFocused
        ? '#F8F8F8'
        : 'white', // Different background colors for selected, focused, and default
    color: state.isSelected ? 'white' : '#000',
    '&:hover': {
      backgroundColor: '#F8F8F8', // Light background on hover
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#3b3b3b',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#000',
  }),
};

const formatCurrency = (value) => {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`; // Convert to millions with one decimal
  } else if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`; // Convert to thousands with one decimal
  }
  return value; // For values less than 1K, display the raw number
};





const getRiskColor = (value, max = 25) => {
  const v = Math.max(0, Math.min(max, Number(value) || 0));
  const ratio = v / max;

  // blue (low) → red (high)
  const r = Math.round(59 + ratio * (239 - 59));   // 59 → 239
  const g = Math.round(130 - ratio * 70);          // 130 → 60
  const b = Math.round(246 - ratio * 200);         // 246 → 46

  return `rgb(${r}, ${g}, ${b})`;
};

const getTrendArrow = (value, history) => {
  if (history == null || value == null) return null;

  if (history - value > 0) return "down"; // improvement
  if (history - value < 0) return "up";   // worse
  return null;
};








const ManageSubRiskCenter = (props) => {

  const {deleteDepartmentFN, users, assignControlToRiskFN, assignable_controls, getControlsReportFN, activeComplianceId, setSidebarCollapsedFN, sidebar_collapsed, companies, go_to_risk_dashboard, gotoRiskDashboardFN, go_to_bowtie, gotoBowtieFN, departments, getComplianceStandardsByCompanyFN, risk_dashboard_data, getRiskDashboardDataFN, activeDepartmentId, closeIncidentFN, closeOverlayFN, framework, complianceStandards, editRiskSaveFN, mode, risk, levels, getRiskFN, getLevelsFN, close, openIncident, risk_id, addCommentFN, addControlFN, addActionFN, /*addAttachmentFN,*/ editRiskFN, editControlFN, editActionFN, profile, deleteControlFN, openControl, controlopen, openAction, actionopen, deleteActionFN, aiControlDropFN } = props;
  const [activeTab, setActiveTab] = useState("users");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeDep, setActiveDep] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);



  const openpopup = () => {
    setIsPopupOpen(true);
  };


  const { id } = useParams();

  const history = useHistory();


  useEffect(() => {
  if (!departments || !id) return;

  const found = departments.find(
    (d) => String(d.department_id) === String(id)
  );
  console.log("Found " , found)
  if (found) {
    setActiveDep(found);
  }
}, [departments, id]);


  const handleDeleteRiskCenter = async () => {
    await deleteDepartmentFN(id);
    setDeleteConfirmOpen(false);
    history.push("/risk_center");
  };

  const changeActiveDepartment = (id) => {
    history.push('/risk_center', { activeMenuItem: 'risk', departmentfromredirect: id });

  };

  const changeActiveCompliance = (id) => {

    history.push('/risk_center', { activeMenuItem: 'risk', ComplianceFromRedirect: id });
  };

  const setMenuItem = (id) => {
    ////console.log(id)
    history.push('/risk_center', { activeMenuItem: id, departmentfromredirect: activeDepartmentId });
  }


  const MATRIX_TOP_PAD = 7;
  const ICON_SIDEBAR_W = 64;
  const UNITS_SIDEBAR_W = 218;

  const leftOffset = ICON_SIDEBAR_W + (sidebar_collapsed ? 0 : UNITS_SIDEBAR_W);

  return (
    <div className="w-full h-screen overflow-hidden bg-[#F8F8F8]">
      {/* TOP BAR */}
      <div className="fixed top-0 left-0 right-0 h-[64px] z-[200]">
        <TopBar />
      </div>

      {/* LEFT ICON SIDEBAR */}
      <div className="fixed top-[64px] left-0 bottom-0 w-[64px] z-[120]">
        <Sidebar />
      </div>

      {!sidebar_collapsed && (
        <div className="fixed top-[64px] left-[64px] bottom-0 w-[218px] z-[130]">
          <UnitsSideBar
            activeDepartmentId={activeDepartmentId}
            departments={departments}
            companies={companies}
            setActiveDepartment={changeActiveDepartment}
            setActiveCompliance={changeActiveCompliance}
          />
        </div>
      )}

      <div
            className="fixed top-[64px] right-0 h-[64px] z-[150] bg-[#F4F4F4] border-b border-[#E5E7EB] transition-[left] duration-300 ease-in-out"
            style={{ left: `${leftOffset}px` }}
          >
            <div className="h-full px-6 flex items-center gap-6">
    
              {/* Sidebar Toggle (only when collapsed) */}
              {sidebar_collapsed && (
                <button
                  onClick={() => setSidebarCollapsedFN(false)}
                  className="flex items-center justify-center w-9 h-9 rounded-lg hover:bg-[#F3F4F6] transition"
                  title="Expand sidebar"
                >
                  <LuPanelLeft className="w-5 h-5 text-[#3b3b3b] hover:text-black" />
                </button>
              )}
    
              {/* Tabs */}
              <div className="flex items-center gap-8 h-full">
                {[
                  { key: "users", label: "Users", icon: "fas fa-users" },
                  { key: "settings", label: "Settings", icon: "fas fa-cog" },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`flex items-center gap-2 h-full text-[13px] border-b-2 transition ${activeTab === tab.key
                        ? "border-[#2563EB] text-[#2563EB] font-medium"
                        : "border-transparent text-[#6B7280] hover:text-[#111827]"
                      }`}
                  >
                    <i className={`${tab.icon} text-[14px]`} />
                    {tab.label}
                  </button>
                ))}
              </div>
    
            </div>
          </div>

      {/* MAIN CONTENT */}
      <div className="w-full h-full pt-[128px] overflow-visible">
        <div
          className="h-full overflow-y-auto bg-[#F8F8F8] transition-[padding-left] duration-300 ease-in-out"
          style={{ paddingLeft: `${leftOffset}px` }}
        >
          {/* HEADER */}
        <div className="bg-[#F8F8F8] px-8 py-6">
            <h1 className="text-[24px] font-semibold text-[#111827]">
              Sub Risk Center Management Portal
            </h1>
            <p className="text-[14px] text-[#6B7280] mt-1">
              Manage users and notifications across your department
            </p>
          </div>

       

          {/* CONTENT - no extra side padding */}
          
          <div className="mt-6">
            {(activeTab === "users" && activeDep) && (
              <div className="w-full px-8 pt-6">
                <div className="w-full">
                  <NotificationsOverlay
                    department={activeDep}
                  />
                </div>
              </div>
            )}

            {activeTab === "riskCenters" && (
              <div>
                <DepartmentsScreen company_id={id} />
              </div>
            )}

            {activeTab === "riskAssessment" && (
              <div>
                <RiskAssessmentScreen company_id={id} />
              </div>
            )}

            {activeTab === "settings" && (
              <div className="mx-8 bg-white border border-[#E5E7EB] rounded-[14px] p-6">
                <h2 className="text-[18px] font-semibold text-[#111827] mb-2">
                  Danger Zone
                </h2>

                <p className="text-[13px] text-[#6B7280] mb-5">
                  Delete this risk center and return to the risk center list.
                </p>

                <button
                  onClick={() => setDeleteConfirmOpen(true)}
                  className="rounded-[8px] bg-red-600 px-4 py-2 text-[13px] font-medium text-white hover:bg-red-700"
                >
                  Delete Risk Center
                </button>
              </div>
            )}

            {deleteConfirmOpen && (
              <div className="fixed inset-0 z-[300000] flex items-center justify-center bg-black/30">
                <div className="w-[420px] rounded-[16px] bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
                  <h3 className="text-[18px] font-semibold text-[#111827]">
                    Are you sure?
                  </h3>

                  <p className="mt-2 text-[13px] text-[#6B7280]">
                    This will delete this risk center. This action cannot be undone.
                  </p>

                  <div className="mt-6 flex justify-end gap-3">
                    <button
                      onClick={() => setDeleteConfirmOpen(false)}
                      className="rounded-[8px] border border-[#E5E7EB] bg-white px-4 py-2 text-[13px] text-[#374151] hover:bg-gray-50"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleDeleteRiskCenter}
                      className="rounded-[8px] bg-red-600 px-4 py-2 text-[13px] font-medium text-white hover:bg-red-700"
                    >
                      Yes, Delete
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );


};


const mapStateToProps = (state) => {
  ////console.log("Riks Data", state.dashboard.risk_dashboard_data,)
  return {
    risk: state.risk.risk,
    profile: state.profile.profile,
    levels: state.risk.levels,
    risk_id: state.risk.id,
    framework: state.risk.risk?.risk?.Framework,
    activeDepartmentId: state.department.activeDepartmentId,
    mode: state.risk.risk?.risk?.riskType,
    risk_dashboard_data: state.dashboard.risk_dashboard_data,
    complianceStandards: state.compliance.complianceStandards,
    departments: state.department.departments,
    go_to_bowtie: state.risk.go_to_bowtie,
    go_to_risk_dashboard: state.risk.go_to_risk_dashboard,
    companies: state.department.companies,
    sidebar_collapsed: state.auth.sidebar_collapsed,
    activeComplianceId: state.compliance.activeComplianceId,
    assignable_controls: state.risk?.risk_controls,
    users: state.admin.admin_users,
  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    getRiskFN: (id) => dispatch(getRisk(id)),
    addCommentFN: (comment, risk_id) => dispatch(addComment(comment, risk_id)),
    addControlFN: (risk_id, owner_id) => {
      return dispatch(addControl(risk_id, owner_id));  // Ensure it returns the Promise
    },
    addActionFN: (risk_id) => dispatch(addAction(risk_id)),
    addAttachmentFN: (risk_id, control_id, file) => dispatch(addAttachment(risk_id, control_id, file)),
    editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
    editRiskSaveFN: (risk_id, risk) => dispatch(editRiskSave(risk_id, risk)),
    editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
    editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
    deleteControlFN: (risk_id, action_id) => dispatch(deleteControl(risk_id, action_id)),
    deleteActionFN: (risk_id, action_id) => dispatch(deleteAction(risk_id, action_id)),
    getLevelsFN: () => dispatch(getLevels()),
    aiControlDropFN: (risk_id, control_data) => dispatch(aiControlDrop(risk_id, control_data)),
    closeOverlayFN: () => dispatch(closeOverlay()),
    closeIncidentFN: () => dispatch(closeIncident()),
    getRiskDashboardDataFN: (risk_id) => dispatch(getRiskDashboardData(risk_id)),
    getComplianceStandardsByCompanyFN: () => dispatch(getComplianceStandardsByCompany()),
    gotoBowtieFN: (id) => dispatch(gotoBowtie(id)),
    gotoRiskDashboardFN: (id) => dispatch(gotoRiskDashboard(id)),
    setSidebarCollapsedFN: (collapsed) =>
      dispatch(setSidebarCollapsed(collapsed)),
    deleteDepartmentFN: (id) => dispatch(deleteDepartment(id)),
    getControlsReportFN: (departmentId) => dispatch(getControls_Report(departmentId)),
    assignControlToRiskFN: (control_id, risk_id) => dispatch(assignControlToRisk(control_id, risk_id)),
    deleteCompanyFN: (id) => dispatch(deleteCompany(id)),
  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(ManageSubRiskCenter);